import React from 'react';

/**
 * ============================================
 * Section Statistiques - Style Modatex
 * ============================================
 * Affichage simple et élégant des statistiques
 */

const StatsSection = ({ totalProducts, outOfStockCount }) => {
    return (
        <section className="w-full py-8 bg-white border-b border-gray-200 mt-20">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-2 gap-6 max-w-2xl mx-auto">
                    {/* Total Products */}
                    <div className="text-center">
                        <p className="text-4xl font-bold text-[#3D3D3D] mb-2">{totalProducts}</p>
                        <p className="text-sm text-gray-600 font-medium uppercase tracking-wide">Produits</p>
                    </div>

                    {/* Out of Stock */}
                    <div className="text-center">
                        <p className="text-4xl font-bold text-[#3D3D3D] mb-2">{outOfStockCount}</p>
                        <p className="text-sm text-gray-600 font-medium uppercase tracking-wide">Épuisé</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default StatsSection;
